"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Modal_1 = __importDefault(require("@mui/material/Modal"));
const fa_1 = require("react-icons/fa");
const IconButton_1 = __importDefault(require("@/components/IconButton"));
const style_1 = require("./style");
const material_1 = require("@mui/material");
function ModalComponent({ children, isOpen, onClose, title, }) {
    return (react_1.default.createElement(Modal_1.default, { open: isOpen, onClose: onClose },
        react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(style_1.StyledBox, null,
                " ",
                react_1.default.createElement(style_1.TitleSection, null,
                    react_1.default.createElement(material_1.Typography, { variant: "h3" }, title),
                    react_1.default.createElement(IconButton_1.default, { onClick: onClose, icon: fa_1.FaTimes })),
                react_1.default.createElement(style_1.Content, null, children)))));
}
exports.default = ModalComponent;
